module.exports = require('./helpers/bundle-url').getBundleURL('7kNAC') + "../../../../23.5a7c5eef.avif" + "?" + Date.now();